import React, { ReactNode } from 'react';
import { VirtualCoreSummary } from '../../interfaces';
import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';

const coreIconStyle: SxProps<Theme> = {
  border: '1px solid #404040',
  borderRadius: '50%',
  padding: '.3rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    color: '#404040',
  },
};

interface CoreSummaryProps extends VirtualCoreSummary {
  icon: ReactNode;
  totalContributions: number;
  name: string;
  maturity: number | null;
}

const CoreSummary: React.FC<CoreSummaryProps> = (props) => {
  return (
    <Stack
      className="core-summary-bg-color"
      display={'flex'}
      flexDirection={'row'}
      px={1}
      py={0.75}
      alignItems={'center'}
      gap={0.5}
    >
      <Box sx={coreIconStyle} className="core-summary-icon" color={'green'}>
        {props.icon}
      </Box>
      <Box
        display={'flex'}
        justifyContent={'flex-start'}
        flexDirection={'column'}
        alignItems={'flex-start'} // Add this line
      >
        <Typography fontSize={'10px'} color={'#404040'} fontWeight={500}>
          {props.name}
        </Typography>
        <Typography fontSize={'10px'} color={'#404040'} fontWeight={400}>
          Elo Rating : {props.maturity}
        </Typography>
      </Box>
    </Stack>
  );
};

export default CoreSummary;
